import { useContext, useEffect } from 'react';
import { AxiosError } from 'axios';
import AppContext from '@context';
import { JourneyGetPayloadInterface } from '@interface/journeys';
import { getJourneysDebounced } from '@services/journeys';

let isListener = false;

const useFilters = () => {
  const {
    state: { filters },
    dispatch,
  } = useContext(AppContext);

  async function updateList({ page = 1 }: JourneyGetPayloadInterface) {
    dispatch({ type: 'journeys_load' });

    try {
      const response = await getJourneysDebounced({
        page,
        filters,
      });

      dispatch({
        type: 'journeys_load_success',
        payload: {
          journeyResponse: response,
        },
      });
      dispatch({
        type: 'journeys_update_current_page',
        payload: {
          currentPage: response.meta.page,
        },
      });
    } catch (error) {
      const err = error as AxiosError;

      if (err?.code === 'ERR_CANCELED') {
        return;
      }

      dispatch({
        type: 'journeys_load_error',
        payload: {
          statusCode: err?.status,
        },
      });
    }
  }

  function addListener() {
    isListener = true;
  }

  useEffect(() => {
    if (isListener) {
      updateList({ page: 1 });
    }
  }, [filters.status]);

  return { addListener };
};

export default useFilters;
